import Actions from './actions';
import Api from './email-integrations-api';
import Collection from './email-integrations-collection';
import Model from './email-integrations-model';
import reducer from './reducers';
import rootSaga from './sagas';
import Selectors from './email-integrations-selectors';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'emailIntegrations',
  reducer,
  sagas:     [rootSaga],
  Selectors,
};
